// ============================================
// Settings Store (Zustand)
// 설정 상태 관리
// ============================================

import { createStore } from 'zustand/vanilla';
import { persist } from 'zustand/middleware';

export const useSettingsStore = createStore(
  persist(
    (set, get) => ({
      // ============================================
      // State
      // ============================================

      // AI 모델 설정
      selectedModel: 'gemini-3-flash-preview',

      // 프로필 선택 UI
      selectedProfileForChange: null,
      inlineProfileSelectorOpen: false,
      inlineSelectedGender: '남성',

      // ============================================
      // Actions - Model Settings
      // ============================================

      setSelectedModel: (model) => set({ selectedModel: model }),

      // ============================================
      // Actions - Profile UI
      // ============================================

      setSelectedProfileForChange: (profileId) => set({ selectedProfileForChange: profileId }),

      setInlineProfileSelectorOpen: (open) => set({ inlineProfileSelectorOpen: open }),

      setInlineSelectedGender: (gender) => set({ inlineSelectedGender: gender }),

      // ============================================
      // Actions - Load from Chat
      // ============================================

      loadFromChatData: (chatData) => {
        if (chatData?.settings) {
          set({
            selectedModel: chatData.settings.model || 'gemini-3-flash-preview'
          });
        }
      },

      // ============================================
      // Actions - Reset
      // ============================================

      resetToDefaults: () => set({
        selectedModel: 'gemini-3-flash-preview'
      }),

      // ============================================
      // Selectors
      // ============================================

      getSettings: () => {
        const state = get();
        return {
          model: state.selectedModel
        };
      }
    }),
    {
      name: 'chatai-settings',
      partialize: (state) => ({
        selectedModel: state.selectedModel
      })
    }
  )
);

export default useSettingsStore;
